import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "inclusive", "max", "min"];
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { filterProps } from 'foundations-components/utils/filterProps';
import { useEffect } from 'react';
import styled from 'styled-components';
import { GRID_BREAKPOINT_EXTRA_LARGE, GRID_BREAKPOINT_LARGE, GRID_BREAKPOINT_MEDIUM, GRID_BREAKPOINT_SMALL } from '../constants';
import { jsx as _jsx } from "react/jsx-runtime";
const breakpoints = {
  xs: '0px',
  sm: GRID_BREAKPOINT_SMALL,
  md: GRID_BREAKPOINT_MEDIUM,
  lg: GRID_BREAKPOINT_LARGE,
  xl: GRID_BREAKPOINT_EXTRA_LARGE
};
function getMediaQueryOperator(operator, inclusive) {
  return inclusive ? operator : `${operator}=`;
}
function useMediaQueryCssObject({
  inclusive,
  max,
  min
}) {
  const queries = [];
  if (max) {
    queries.push(`(width ${getMediaQueryOperator('>', inclusive)} ${breakpoints[max]})`);
  }
  if (min) {
    queries.push(`(width ${getMediaQueryOperator('<', inclusive)} ${breakpoints[min]})`);
  }
  return queries.length ? {
    [`@media only screen and ${queries.join(' and ')}`]: {
      display: 'none'
    }
  } : {};
}
const StyledMediaQueryView = styled.div.withConfig({
  displayName: "MediaQueryView__StyledMediaQueryView"
})(({
  $cssStyles,
  $max,
  $min,
  $inclusive
}) => {
  const mediaQueryCssObject = useMediaQueryCssObject({
    inclusive: $inclusive,
    max: $max,
    min: $min
  });
  return Object.assign({}, $cssStyles, mediaQueryCssObject);
});
export function MediaQueryView(_ref) {
  let {
      children,
      inclusive,
      max,
      min
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(restProps);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  useEffect(() => {
    if (!(max || min)) {
      console.warn('[MediaQueryView] No breakpoints provided.');
    }
  }, [max, min]);
  if (!(max || min)) {
    return children;
  }
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(StyledMediaQueryView, Object.assign({
      $cssStyles: cssStyles,
      $inclusive: inclusive || !!max,
      $max: max,
      $min: min
    }, domProps, {
      children: children
    }))
  );
}